import { StyleDeclarationValue, css } from 'aphrodite';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	styles?: StyleDeclarationValue[];
}

export function ThankYouMessage({ className = '', styles = [] }: IProps) {
	return (
		<div className={`${css(styleSheet.container, ...styles)} ${className}`}>
			<div>
				<p>Thank you for your response.</p>
				<p>You can now close the window.</p>
			</div>
		</div>
	);
}
